import { Component, OnInit, ViewChild, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogConfig } from '@angular/material';
import { RequestReponse } from './shared/model/request-reponse.model';
import { CheckDocumentsComponent } from './check-documents/check-documents.component';
import { DocumentoDeliveryRequest } from './shared/model/documento-delivery-request.model';
import { RequestService } from './shared/request.service';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';

@Component({
  selector: 'app-requets',
  templateUrl: './requets.component.html',
  styleUrls: ['./requets.component.scss']
})
export class RequetsComponent implements OnInit, OnChanges {

  displayedColumns: string[] ;
  dataSource: MatTableDataSource<RequestReponse>;
  selection = new SelectionModel<RequestReponse>(true, []);
  @Input() request: RequestReponse [];
  @Input() tipoResultado = 1;
  @Input() isPifle = false;

  @Output()
  sendSearchRequest: EventEmitter<any> = new EventEmitter();

  @Output()
  changeSpinner: EventEmitter<any> = new EventEmitter();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private dialog: MatDialog,
              private router: Router,
              private requestService: RequestService) {
     this.dataSource = new MatTableDataSource(this.request);
     if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
   }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.generateColumn();
  }

  ngOnChanges() {
    this.dataSource = new MatTableDataSource(this.request);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  assignSingle(row) {
    const param = JSON.stringify(row);
    this.router.navigate(['evaluaciones/asignar-evaluador-materias'], { queryParams: { request : param , isEvaluation : false } });
  }

 /** Selects all rows if they are not all selected; otherwise clear selection. */
 masterToggle() {
  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  openDialog(request) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { request: request, index: request.solicitud};
    dialogConfig.width = '70%';
    const dialogRef = this.dialog.open(CheckDocumentsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value !== null) {
          if (value.documents !== '') {
            const documentRequest = new DocumentoDeliveryRequest();
            documentRequest.documentos = value.documents;
            documentRequest.solicitud = value.index.solicitud;
            documentRequest.tipo = value.index.tipo;
            documentRequest.usuario =  decodeURIComponent(localStorage.getItem('usuario'));
            this.changeSpinner.emit(true);
            this.requestService.sendDocumentsDelivery(documentRequest).subscribe(
              (result) => {
                this.sendSearchRequest.emit();
              }
            );
          }
        }
    });
  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  private generateColumn() {
    switch (this.tipoResultado) {
      case 1:
        this.displayedColumns = ['fecha', 'codigo', 'cedula', 'nombre', 'facultad', 'programa', 'recibir'];
      break;
      case 2:
        this.displayedColumns = ['seleccion', 'fecha', 'codigo', 'cedula', 'nombre', 'facultad', 'programa', 'asignar'];
      break;
    }
  }

}
